//Google Site Search:
(function () {
    var cx = '008302519017309215535:bdpptmkj-5w';
    var gcse = document.createElement('script');
    gcse.type = 'text/javascript';
    gcse.async = true;
    gcse.src = (document.location.protocol == 'https:' ? 'https:' : 'http:') +
        '//www.google.com/cse/cse.js?cx=' + cx;
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(gcse, s);
})();

// var IntervalleVerificationRechercheGoogle = window.setInterval(function () {
    /*var ChampRecherche = $('#Entete #RechercheGoogle #gsc-i-id1');
    if (ChampRecherche.length) {*/
        /*var EtiquetteChampRecherche = $('#Entete #RechercheGoogle label[for="gsc-i-id1"]');
        if(!ChampRecherche.val()) {
            EtiquetteChampRecherche.show();
        }
        EtiquetteChampRecherche.click(function() {
            EtiquetteChampRecherche.hide();
        });
        ChampRecherche.focus(function() {
            EtiquetteChampRecherche.hide();
        });
        ChampRecherche.blur(function() {
            if(!ChampRecherche.val()) {
                EtiquetteChampRecherche.show();
            }
        });*/
        /*$('#Entete #RechercheGoogle input[name="search"]').attr('placeholder', MH.Langue == 'fr' ? 'Recherche' : 'Search').css('text-indent', 0);
        window.clearInterval(IntervalleVerificationRechercheGoogle);
    }*/
// }, 100);

/*var IntervalleVerificationRechercheGoogle = window.setInterval(function () {
    console.log('#')
    var ChampRecherche = document.querySelector('#gsc-i-id1');
    if (ChampRecherche) {
        var input = ChampRecherche.querySelector('input[name="search"]');
        input.placeholder = document.documentElement.lang === 'fr' ? 'Recherche' : 'Search';
        input.style.textIndent = 0;
        window.clearInterval(IntervalleVerificationRechercheGoogle);
    }
}, 100);*/
